(function () {
  'use strict';
  const ATIVO = true, INATIVO = false;

  angular
    .module('FeatureFlagModule')
    .constant('FeatureFlag', {
      /**
       * Ativa ou inativa verificação de soluções.
       * @type {boolean}
       */
      SOLUCOES: ATIVO,
      SOLUCOES_AVISO: INATIVO,
      CONFIG_NOTIFICACAO_OCORRENCIA: ATIVO,
      SNAPSHOTS_HIST_DETALHADO: ATIVO,
      DOCUMENTOS_MOTORISTA: ATIVO,
      SNACKBAR_PRODUCT_VALIDATION: INATIVO,
      ADVISOR: ATIVO,
      TUTORIAL_BUSCA_REGIAO: INATIVO,
      DIALOG_PONTO_REESTRUTURADO: ATIVO,
      VIGENCIA_PROGRAMADA: ATIVO,
      MENU_INSIGHTS: ATIVO,
      SOLUCAO_REC_FACIAL: ATIVO,
      EXPORTAR_PDF_HISTORICO_OCORRENCIAS: ATIVO,
      SHOW_EVENT_DIALOG: ATIVO,
      SHOW_HARSH_EVENTS_RISK_REGION: ATIVO,
      SHOW_ULTRAPASSAGEM_ILEGAL: ATIVO
    })
    .constant('FeatureHubConfigKeys', {
      ENABLE_PLAYBACK_CONTENT: 'TTLAV777_Playback_content',
      ENABLE_6_CAMERAS: 'TTLAV1145_videos_with_6_cameras',
      ENABLE_FEAT_ROLE_PRONTUARIO_VISUALIZAR: 'TTLAINT1512_role_PRONTUARIO_MOTORISTA_VISUALIZAR',
      FEATURE_VSAFE_BOLETIM: 'TTLATEL1853_vsafe_boletim',
      FEATURE_INTEGRATION_SUPPLIER_ENABLE: 'TTLAINT1738_add_column_data_integrator_to_alerts_board',
      DECORATED_VIDEO_PLAYER: 'STFM_974_DISPLAY_DECORATED_VIDEO_PLAYER_V3',
      DEVICE_HEALTH_PAGE: 'STFM-1371-DeviceHealth',
      DEVICE_HEALTH_TELEMATICS_TABLE: 'LAINT18_telematics_table',
      ENABLE_INTEGRATION_CODE_LANDMARK: 'TTLATEL1891_integration_code_landmark',
      COLLAPSIBLE_TABLES: 'STFM1206_collapsible_tables',
      FEATURE_THUMBNAILS_BUTTON: 'STFM1263_thumbnails_buttons',
      SEPARATE_STABILITY_CONTROL: 'STFM-1217_separate_stability_control',
      ENABLE_RETENTION_PERIOD: 'STFM1332_retention_period_configuration',
      FIX_UI_BEHAVIOR: 'STFM1392_fix_ui_behavior',
      ENABLE_DRIVER_LINK: 'TTLAINT1555_driver_link',
      ENABLE_DEVICE_HEALTY_NOTIFICATION_SETTINGS: 'STFM-1380_device_health_notification_configuration',
      ENABLE_EXCEEDED_PERMANENCIA_REALTIME: 'LATEL390_EXCEEDED_PERMANENCIA_REALTIME',
      ORION_HIDE_TITLE: 'PVPH44_hide_title',
      COACHING_PAGE: 'PVS_187_COACHING_PAGE_NAVIGATION',
      USE_NEW_TILES_SOURCE: 'LAINT_692_NEW_TILES_SOURCE',
      ENABLE_DRIVER_PRIVACY: 'PVS-334_driver_privacy',
      DECORATED_MODAL_WITHOUT_VIDEO: 'PVS_109_DECORATED_MODAL_WITHOUT_VIDEO'
    });
}());
